export class PasswordValidator {
  constructor(
    public minLength: number,
    public minUpperCase?: number,
    public minLowerCase?: number,
    public minDigits?: number,
  ) {}

  isValid(password: string) {
    return (
      this.isMinLengthValid(password) &&
      this.isMinUpperCaseValid(password) &&
      this.isMinLowerCaseValid(password) &&
      this.isMinDigitsValid(password)
    );
  }

  isMinLengthValid(password: string) {
    return password.length >= this.minLength;
  }

  isMinUpperCaseValid(password: string) {
    const minLength = Math.max(0, this.minUpperCase ?? 0);
    return (password.match(/[A-Z]/g) ?? '').length >= minLength;
  }

  isMinLowerCaseValid(password: string) {
    const minLength = Math.max(0, this.minLowerCase ?? 0);
    return (password.match(/[a-z]/g) ?? '').length >= minLength;
  }

  isMinDigitsValid(password: string) {
    const minLength = Math.max(0, this.minDigits ?? 0);
    return (password.match(/[0-9]/g) ?? '').length >= minLength;
  }
}
